import React, { useMemo, useState } from "react";
import { Button, Icon, Label } from "semantic-ui-react";

/**
 * AIMovementSuggestion
 * Renders an optional AI suggestion object/string coming from `aiInvoiceMovementMatchSuggestion`.
 * Defensive by design: backend payload shape may evolve.
 */
const AIMovementSuggestion = ({ suggestion, invoice, readOnly = false }) => {
  const [open, setOpen] = useState(false);

  const hasSuggestion = useMemo(() => {
    if (suggestion == null) return false;
    if (typeof suggestion === "string") return suggestion.trim().length > 0;
    if (Array.isArray(suggestion)) return suggestion.length > 0;
    if (typeof suggestion === "object") return Object.keys(suggestion).length > 0;
    return true;
  }, [suggestion]);

  const title = useMemo(() => {
    if (typeof suggestion === "object" && suggestion?.title) return String(suggestion.title);
    return "Sugerencia IA (movimientos)";
  }, [suggestion]);

  const summary = useMemo(() => {
    if (typeof suggestion === "string") return suggestion;
    if (typeof suggestion === "object") {
      const s =
        suggestion?.summary ??
        suggestion?.explanation ??
        suggestion?.reason ??
        suggestion?.message;
      if (s != null) return String(s);
    }
    return null;
  }, [suggestion]);

  if (!hasSuggestion) return null;

  return (
    <div className="ai-movement-suggestion" style={{ marginBottom: 16 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
          marginBottom: 8,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Label color="violet" size="tiny">
            IA
          </Label>
          <div style={{ fontWeight: 700, color: "var(--text-high)" }}>{title}</div>
          {!!invoice?.meta?.documentId && (
            <div style={{ color: "var(--text-mid)", fontSize: 12 }}>
              Doc {invoice.meta.documentId}
            </div>
          )}
        </div>

        <Button
          size="mini"
          basic
          type="button"
          disabled={readOnly}
          onClick={() => setOpen((v) => !v)}
        >
          <Icon name={open ? "angle up" : "angle down"} />
          {open ? "Ocultar" : "Ver"}
        </Button>
      </div>

      {!!summary && !open && (
        <div style={{ color: "var(--text-mid)", fontSize: 12, lineHeight: 1.35 }}>
          {summary}
        </div>
      )}

      {open && (
        <pre
          style={{
            background: "rgba(140, 82, 255, 0.06)",
            border: "1px solid rgba(140, 82, 255, 0.18)",
            borderRadius: 8,
            padding: 12,
            margin: 0,
            overflowX: "auto",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            color: "var(--text-high)",
            fontSize: 12,
            lineHeight: 1.35,
          }}
        >
          {typeof suggestion === "string"
            ? suggestion
            : JSON.stringify(suggestion, null, 2)}
        </pre>
      )}
    </div>
  );
};

export default AIMovementSuggestion;

